import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { CertificateUploadService } from '../../../services/zertifikat-upload.service';

@Component({
  selector: 'app-add-certificate',
  imports: [
    FormsModule,
    MatButton,
    MatLabel,
    MatFormField,
    MatInput,
    MatLabel,
    MatFormField,
    TranslatePipe,
  ],
  templateUrl: './add-certificate.component.html',
  styleUrl: './add-certificate.component.scss',
  standalone: true,
})
export class AddCertificateComponent implements OnInit {
  newCertificate: string;
  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<void>();
  @Input() type: string;

  constructor(private certificateUploadService: CertificateUploadService) {}

  onBackdropClick() {
    this.onClose();
  }

  onClose() {
    this.close.emit();
  }

  ngOnInit() {
    this.newCertificate = '';
  }

  onSave() {
    if (!this.newCertificate) return;

    this.certificateUploadService.postName(this.newCertificate).subscribe({
      next: () => {
        this.saved.emit();
        this.close.emit();
      },
      error: (err) => {
        console.error('Error creating ', this.type, err);
      },
    });
  }
}
